// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2We9p","input":"styles_input__38dXO"};